import React from 'react';
import r from '../../../images/reactjs-2.png';
import j1 from '../../../images/js.png';
import j2 from '../../../images/images.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './Blogs.css';

const blogs = [
    {
        img: j1,
        title: 'Important things about JavaScript',
        description: 'Today I will go and discuss 10 important topics of JavaScript. I think you are excited. So, Let’s start without Wasting Time...',
        link: 'https://masumiraj0218.medium.com/10-important-things-about-javascript-b35238e6ad41'
    },
    {
        img: j2,
        title: 'JavaScript 10 Interview Questions',
        description: 'Hello there, I’m sharing some JavaScript interview questions. So, Let’s start without Wasting Time...',
        link: 'https://masumiraj0218.medium.com/javascript-10-interview-questions-722620b59ff5'
    },
    {
        img: r,
        title: 'Basic information about React.JS',
        description: 'Today I will go and discuss 10 basic information of React.JS. I think you are excited. So, Let’s start...',
        link: 'https://masumiraj0218.medium.com/basic-information-about-react-js-5f95c825c614'
    }
];

const Blogs = () => {
    return (
        <div className="container blogs-area pt-5 my-5">
            <h3 className="Title mt-5">Blog</h3>

            <h4 className="mb-5 sub-title">Latest Blogs</h4>

            <div className="row">
                {   
                    blogs.map(blog => 
                        <div className="col-md-4">
                            <div className="blog-info">
                                <img src={blog.img} alt="" />
                                <div className="mx-3 mt-4 pb-4">
                                    <h4>{blog.title}</h4>
                                    <p>{blog.description}</p>
                                    <a href={blog.link} target="_blank">Continue Reading <FontAwesomeIcon className="ml-2" icon={faArrowRight} /></a>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default Blogs;